(() => {
  if (customElements.get('guilds-picker-state')) return;
  const states = new Map();
  class GuildsPickerState extends HTMLElement {
    connectedCallback() {
      this.abort = new AbortController();
      this.picker = this.querySelector('variant-picker');
      this.key = this.picker?.id;
      if (!this.key) return;
      // Every draft request carries its own preview key. Shopify's product preview
      // cookie can otherwise point at the other configurator in another tab.
      const info = this.closest('product-info');
      // Keep only one live set of radio controls; hidden old radios otherwise
      // share names with the new controls during the theme's 500 ms transition.
      if(info&&!info.guildsSelectionSync){
        const nativeOptions=info.updateOptionValues;
        if(typeof nativeOptions==='function')info.updateOptionValues=function(html){
          const previous=this.variantSelectors;nativeOptions.call(this,html);
          if(previous?.isConnected&&previous.style.display==='none')previous.remove();
        };
        const nativeRender=info.renderProductInfo;
        if(typeof nativeRender==='function')info.renderProductInfo=function(args){
          const revision=this.guildsSelectionRevision=(this.guildsSelectionRevision||0)+1,callback=args.callback;
          return nativeRender.call(this,{...args,callback:html=>{if(revision===this.guildsSelectionRevision)callback?.(html);}});
        };
        info.guildsSelectionSync=true;
      }
      const previewKeys = {
        '10474564714778': 'd911fae724773191b1a258c5514647b8',
        '10478481473818': '8eb0f01c452df87243f542c2f2adfdba'
      };
      const previewKey = info?.querySelector('zenith-configuration-summary[data-preview-only]') ? previewKeys[info.getAttribute('data-product-id')] : null;
      if (previewKey && info && !info.guildsPreviewRouting) {
        const nativeBuild = info.buildRequestUrlWithParams;
        if (typeof nativeBuild === 'function') {
          info.buildRequestUrlWithParams = function(url, optionValues) {
            const target = new URL(nativeBuild.call(this, url, optionValues), window.location.origin);
            target.pathname = '/products_preview';
            target.searchParams.set('preview_key', previewKey);
            target.searchParams.set('preview_theme_id', '191767839002');
            return target.toString();
          };
          info.guildsPreviewRouting = true;
        }
      }
      const remember = () => {
        const snapshot = {};
        snapshot.designGroup = this.activeDesignGroup;
        this.querySelectorAll('[data-guilds-disclosure]').forEach(el => { snapshot[el.dataset.guildsDisclosure] = el.open; });
        states.set(this.key, snapshot);
      };
      const restore = () => {
        const snapshot = states.get(this.key);
        if (snapshot) this.querySelectorAll('[data-guilds-disclosure]').forEach(el => {
          if (Object.prototype.hasOwnProperty.call(snapshot, el.dataset.guildsDisclosure)) el.open = snapshot[el.dataset.guildsDisclosure];
        });
        this.setupDesignGroups(snapshot?.designGroup);
        this.restoreSelectionPosition();
      };
      restore();
      this.setupStandalonePreview();
      this.addEventListener('click', event => {
        const button = event.target.closest('[data-guilds-step-next]');
        if (button) this.continueStep(button.dataset.guildsStepNext);
      }, {signal:this.abort.signal});
      this.addEventListener('guilds:product-artwork-done', event => {
        this.continueStep(event.target.closest('guilds-desk-addons') ? 'addons' : 'design');
      }, {signal:this.abort.signal});
      // Capture before VariantPicker starts its section request.
      this.addEventListener('change', event => {
        const field=event.target.closest('[data-option-slug]');
        if(field&&event.target.matches('input[type="radio"],select')){
          const anchor=field.querySelector('[data-product-design-categories]')||field;
          this.selectionPosition={slug:field.dataset.optionSlug,top:anchor.getBoundingClientRect().top,custom:event.target.value==='Custom Design',scrollY:window.scrollY};
        }
        remember();
      }, { capture: true, signal: this.abort.signal });
      this.addEventListener('toggle', event => { if (event.target.matches('[data-guilds-disclosure]')) remember(); }, { capture: true, signal: this.abort.signal });
      // ProductInfo replaces only variant-picker, leaving this wrapper mounted.
      this.observer = new MutationObserver(records => {
        if (records.some(record => [...record.addedNodes].some(node => node.nodeType === 1 && (node.matches?.('variant-picker') || node.querySelector?.('variant-picker'))))) restore();
      });
      this.observer.observe(this, { childList: true, subtree: true });
    }
    setupDesignGroups(preferred) {
      const panel=this.querySelector('[data-guilds-disclosure="design"] .zenith-master-panel');
      if(!panel||panel.querySelector('[data-product-design-categories]'))return;
      const groups=[...panel.querySelectorAll(':scope > .zenith-design-group')].filter(group=>group.querySelector('input[type="radio"]'));
      if(groups.length<2)return;
      const nav=document.createElement('div');nav.className='guilds-product-design-categories';nav.dataset.productDesignCategories='';nav.setAttribute('role','group');nav.setAttribute('aria-label',this.querySelector('[data-guilds-disclosure="design"] summary strong')?.textContent||'');
      const selected=groups.find(group=>group.querySelector('input:checked'));
      const title=group=>group.querySelector('.zenith-group-heading strong')?.textContent.trim()||'';
      const active=groups.find(group=>title(group)===preferred)||selected||groups[0];
      const show=group=>{this.activeDesignGroup=title(group);groups.forEach((item,index)=>{item.hidden=item!==group;nav.children[index].setAttribute('aria-pressed',String(item===group));});};
      groups.forEach(group=>{const button=document.createElement('button');button.type='button';const label=document.createElement('strong');label.textContent=title(group)+' ('+group.querySelectorAll('input[type="radio"]').length+')';button.append(label);const surcharge=group.querySelector('.zenith-group-heading > b');if(surcharge){const amount=document.createElement('small');amount.textContent=surcharge.textContent;button.append(amount);}button.addEventListener('click',()=>{show(group);const custom=group.querySelector('input[type="radio"][value="Custom Design"]');if(custom&&!custom.checked&&!custom.disabled)custom.click();},{signal:this.abort.signal});nav.append(button);});
      panel.prepend(nav);show(active);
    }
    scrollToStep(target){
      cancelAnimationFrame(this.navigationFrame);
      const revision=this.navigationRevision=(this.navigationRevision||0)+1;
      this.navigationFrame=requestAnimationFrame(()=>{this.navigationFrame=requestAnimationFrame(()=>{
        if(!this.isConnected||revision!==this.navigationRevision||!target?.isConnected)return;
        const header=document.querySelector('sticky-header')||document.querySelector('[id$="__header"]');
        const headerBottom=Math.max(0,header?.getBoundingClientRect().bottom||0);
        const preview=this.previousElementSibling?.matches('.guilds-product-selection-preview')?this.previousElementSibling:null;
        const previewHeight=preview&&getComputedStyle(preview).display!=='none'?preview.getBoundingClientRect().height+18:0;
        window.scrollTo({top:Math.max(0,window.scrollY+target.getBoundingClientRect().top-headerBottom-previewHeight-16),behavior:matchMedia('(prefers-reduced-motion:reduce)').matches?'instant':'smooth'});
        if(!target.matches('button,summary,input,select,a,[tabindex]'))target.setAttribute('tabindex','-1');
        target.focus({preventScroll:true});
      });});
    }
    restoreSelectionPosition(){
      const position=this.selectionPosition;if(!position)return;
      const field=[...this.querySelectorAll('[data-option-slug]')].find(node=>node.dataset.optionSlug===position.slug);
      if(!field)return;
      this.selectionPosition=null;
      if(matchMedia('(min-width:1000px)').matches){
        const formId=this.querySelector('zenith-artwork-editor')?.dataset.formId;
        const gallery=[...document.querySelectorAll('guilds-live-gallery')].find(node=>node.dataset.formId===formId&&node.dataset.kind==='zenith');
        if(gallery){gallery.revealSelection?.();return;}
      }
      if(Math.abs(window.scrollY-position.scrollY)>150)return;
      if(position.custom){const editor=this.querySelector('zenith-artwork-editor');if(editor){this.scrollToStep(editor);return;}}
      const anchor=field.querySelector('[data-product-design-categories]')||field;
      cancelAnimationFrame(this.selectionFrame);
      this.selectionFrame=requestAnimationFrame(()=>{this.selectionFrame=requestAnimationFrame(()=>{
        if(this.isConnected&&anchor.isConnected&&Math.abs(window.scrollY-position.scrollY)<150)window.scrollTo({top:Math.max(0,window.scrollY+anchor.getBoundingClientRect().top-position.top),behavior:'instant'});
      });});
    }
    setupStandalonePreview(){
      const formId=this.querySelector('zenith-artwork-editor')?.dataset.formId;
      if(!formId||[...document.querySelectorAll('zenith-purchase-bar')].some(bar=>bar.dataset.formId===formId))return;
      const form=document.getElementById(formId),gallery=[...document.querySelectorAll('guilds-live-gallery')].find(node=>node.dataset.formId===formId);if(!form||!gallery)return;
      const preview=document.createElement('button');preview.type='button';preview.className='guilds-product-selection-preview';
      const image=document.createElement('img');image.alt='';image.width=84;image.height=62;const copy=document.createElement('span'),name=document.createElement('strong'),hint=document.createElement('small');hint.textContent=this.dataset.selectedPreviewLabel+' ↑';copy.append(name,hint);preview.append(image,copy);this.before(preview);this.standalonePreview=preview;
      const back=document.createElement('button');back.type='button';back.className='zenith-preview-return';back.textContent=this.dataset.backToOptions+' ↓';back.hidden=true;gallery.append(back);this.standaloneBack=back;
      const behavior=()=>matchMedia('(prefers-reduced-motion:reduce)').matches?'instant':'smooth';
      preview.addEventListener('click',()=>{back.hidden=false;gallery.scrollIntoView({block:'start',behavior:behavior()});},{signal:this.abort.signal});back.addEventListener('click',()=>this.querySelector('[data-guilds-disclosure="design"]')?.scrollIntoView({block:'start',behavior:behavior()}),{signal:this.abort.signal});
      const refresh=()=>{cancelAnimationFrame(this.standaloneFrame);this.standaloneFrame=requestAnimationFrame(()=>{
        if(!this.isConnected)return;let variant=this.standaloneVariant;try{variant=variant||JSON.parse(this.querySelector('[data-selected-variant]')?.textContent||'null');}catch{}
        name.textContent=variant?.options?.join(' · ')||[gallery.querySelector('[data-gallery-size]')?.textContent,gallery.querySelector('[data-gallery-name]')?.textContent].filter(Boolean).join(' · ');
        const canvas=gallery.querySelector('[data-gallery-canvas]'),visual=gallery.querySelector('[data-gallery-visual]');
        if(canvas&&!visual?.hidden){try{const thumb=document.createElement('canvas');thumb.width=160;thumb.height=118;thumb.getContext('2d').drawImage(canvas,0,0,160,118);image.src=thumb.toDataURL('image/png');image.hidden=false;}catch{image.hidden=true;}}
        else{const photo=gallery.parentElement.querySelector('media-gallery img');const src=variant?.featured_media?.preview_image?.src||variant?.featured_image?.src||photo?.currentSrc||photo?.src;image.hidden=!src;if(src)image.src=src;}
      });};
      form.addEventListener('variant:change',event=>{this.standaloneVariant=event.detail?.variant;refresh();},{signal:this.abort.signal});document.addEventListener('guilds:artwork-preview',event=>{if(event.detail?.editor?.dataset.formId===formId)refresh();},{signal:this.abort.signal});refresh();
    }
    continueStep(step) {
      const scope=this.closest('product-info') || this.closest('[id^="ProductInfo-"]') || this.parentElement;
      const formId=this.querySelector('guilds-desk-addons')?.dataset.formId || this.querySelector('zenith-artwork-editor')?.dataset.formId;
      const form=document.getElementById(formId);
      const guard={target:form,defaultPrevented:false,preventDefault(){this.defaultPrevented=true;},stopImmediatePropagation(){}};
      if(step==='design'){
        const editor=this.querySelector('variant-picker zenith-artwork-editor');
        if(editor&&form){editor.syncSelection();editor.guardSubmit(guard);}
      } else this.querySelector('guilds-desk-addons')?.guardSubmit(guard);
      if(guard.defaultPrevented)return false;
      const current=this.querySelector('[data-guilds-disclosure="'+step+'"]');
      const next=step==='design'?this.querySelector('[data-guilds-disclosure="addons"]'):null;
      const services=[...scope.querySelectorAll('guilds-product-services')].find(el=>el.dataset.formId===formId);
      const destination=next || services?.querySelector('details') || scope.querySelector('product-form') || form;
      if(!destination)return false;
      if(current)current.open=false;
      if(destination.tagName==='DETAILS')destination.open=true;
      this.selectionPosition=null;
      const snapshot={designGroup:this.activeDesignGroup};this.querySelectorAll('[data-guilds-disclosure]').forEach(el=>{snapshot[el.dataset.guildsDisclosure]=el.open;});states.set(this.key,snapshot);
      const target=destination.querySelector('summary') || destination.querySelector('button[type="submit"]') || destination;
      this.scrollToStep(target);
      return true;
    }
    disconnectedCallback() { this.abort?.abort();this.observer?.disconnect();this.standalonePreview?.remove();this.standaloneBack?.remove();cancelAnimationFrame(this.standaloneFrame);cancelAnimationFrame(this.navigationFrame);cancelAnimationFrame(this.selectionFrame); }
  }
  customElements.define('guilds-picker-state', GuildsPickerState);
})();

(() => {
  if (customElements.get('zenith-configuration-summary')) return;

  class ZenithConfigurationSummary extends HTMLElement {
    connectedCallback() {
      this.abort = new AbortController();
      const setup = () => {
        const form = document.getElementById(this.dataset.formId);
        const previewOnly = this.hasAttribute('data-preview-only');
        const labelButtons = () => {
          if (!previewOnly || !form) return;
          document.querySelectorAll(`button[type="submit"][form="${this.dataset.formId}"]`).forEach(button => {
            const text = button.querySelector('.btn-text > span') || button;
            text.textContent = this.dataset.previewLabel;
            button.setAttribute('aria-label', this.dataset.previewLabel);
          });
        };
        labelButtons();
        form?.addEventListener('variant:change', event => {
          const variant = event.detail?.variant;
          if (variant?.options) this.querySelector('[data-zenith-selection]').textContent = variant.options.join(' · ');
          if (previewOnly) {
            labelButtons();
            this.querySelector('[data-preview-status]').textContent = this.previewNotice;
          }
        }, { signal: this.abort.signal });
        if (previewOnly && form) {
          const status = this.querySelector('[data-preview-status]');
          this.previewNotice = status.textContent;
          document.addEventListener('submit', event => {
            if (event.target !== form) return;
            const editor = form.closest('product-info')?.querySelector('zenith-artwork-editor');
            const addons=form.closest('product-info')?.querySelector('guilds-desk-addons');
            addons?.guardSubmit(event);
            if(event.defaultPrevented)return;
            editor?.guardSubmit(event);
            if (event.defaultPrevented) return;
            event.preventDefault();
            event.stopImmediatePropagation();
            form.handleErrorMessage?.();
            status.textContent = editor?.design === 'Custom Design' && editor.state.file ? `${editor.dataset.currentArtwork}: ${editor.state.file.name}. ${this.dataset.previewReady}` : this.dataset.previewReady;
            if(addons?.selected().length)status.textContent+=' '+addons.previewDescription();
          }, { capture: true, signal: this.abort.signal });
        }
      };
      if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', setup, { once: true, signal: this.abort.signal });
      else setup();
    }

    disconnectedCallback() { this.abort?.abort(); }
  }

  class ZenithPurchaseBar extends HTMLElement {
    connectedCallback() {
      this.abort = new AbortController();
      const setup = () => {
        const form = document.getElementById(this.dataset.formId);
        if (!form) return;
        const button = this.querySelector('button[type="submit"]');
        const info = form.closest('product-info');
        const preview = this.querySelector('[data-mobile-design-preview]');
        const gallery = [...document.querySelectorAll('guilds-live-gallery')].find(node => node.dataset.formId === this.dataset.formId);
        const updateVisibility = () => { this.hidden = this.formVisible && !(this.hasSelectionUpdate && !this.galleryVisible); };
        const scrollBehavior = () => matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth';
        this.formVisible = false; this.galleryVisible = false;
        if (gallery && preview) {
          this.selectionPreview=document.createElement('button');this.selectionPreview.type='button';this.selectionPreview.className='guilds-product-selection-preview';
          const thumb=document.createElement('img');thumb.alt='';thumb.width=84;thumb.height=62;thumb.dataset.mobileDesignImage='';
          const copy=document.createElement('span'),name=document.createElement('strong'),hint=document.createElement('small');name.dataset.mobileDesignName='';hint.textContent=this.dataset.selectedPreviewLabel+' ↑';copy.append(name,hint);this.selectionPreview.append(thumb,copy);
          info?.querySelector('guilds-picker-state')?.before(this.selectionPreview);
          let selected=null;try{selected=JSON.parse(info?.querySelector('[data-selected-variant]')?.textContent||'null');}catch{}
          this.currentVariantImage=selected?.featured_media?.preview_image?.src||selected?.featured_image?.src||'';
          name.textContent=selected?.options?.join(' · ')||gallery.querySelector('[data-gallery-name]')?.textContent||'';
          this.selectionPreview.addEventListener('click',()=>{this.backButton.hidden=false;gallery.scrollIntoView({block:'start',behavior:scrollBehavior()});},{signal:this.abort.signal});
          this.galleryObserver = new IntersectionObserver(entries => { this.galleryVisible = entries[0].isIntersecting; updateVisibility(); }, {threshold: 0.15});
          this.galleryObserver.observe(gallery);
          this.backButton = document.createElement('button'); this.backButton.type = 'button'; this.backButton.className = 'zenith-preview-return'; this.backButton.hidden = true; this.backButton.textContent = this.dataset.backToOptions + ' ↓'; gallery.append(this.backButton);
          this.backButton.addEventListener('click', () => { const target = this.returnTarget?.isConnected ? this.returnTarget : info?.querySelector('guilds-picker-state'); target?.scrollIntoView({block:'start',behavior:scrollBehavior()}); }, {signal:this.abort.signal});
          preview.addEventListener('click', () => { this.backButton.hidden = false; gallery.scrollIntoView({block:'start',behavior:scrollBehavior()}); }, {signal:this.abort.signal});
          info?.addEventListener('change', event => { if (event.target.matches('input[type=radio]')) { this.returnFieldsetId = event.target.closest('fieldset')?.id; this.returnTarget = event.target.closest('fieldset'); } }, {signal:this.abort.signal});
          document.addEventListener('guilds:artwork-preview', event => {
            const editor = event.detail?.editor; if (editor?.dataset.formId !== this.dataset.formId || !this.hasSelectionUpdate) return;
            this.updatePreviewThumbnail(gallery);
          }, {signal:this.abort.signal});
          this.updatePreviewThumbnail(gallery);
        }
        const price = this.querySelector('[data-zenith-mobile-price]');
        this.observer = new IntersectionObserver(entries => {
          this.formVisible = entries[0].isIntersecting; updateVisibility();
        }, { threshold: 0.1 });
        this.observer.observe(form);
        form.addEventListener('variant:change', event => {
          const variant = event.detail?.variant;
          if (variant && gallery && preview) {
            this.currentVariantImage=variant.featured_media?.preview_image?.src||variant.featured_image?.src||'';
            this.hasSelectionUpdate = true; preview.hidden = false;
            preview.querySelector('[data-mobile-design-name]').textContent = variant.options?.join(' · ') || variant.title;
            this.selectionPreview.querySelector('[data-mobile-design-name]').textContent=variant.options?.join(' · ')||variant.title;
            this.selectionPreview.classList.add('is-updated');clearTimeout(this.selectionHighlightTimer);this.selectionHighlightTimer=setTimeout(()=>this.selectionPreview?.classList.remove('is-updated'),900);
            preview.querySelector('[data-mobile-design-status]').textContent = this.dataset.previewUpdated;
            this.returnTarget = document.getElementById(this.returnFieldsetId) || info?.querySelector('guilds-picker-state') || this.returnTarget;
            preview.classList.remove('is-updated'); requestAnimationFrame(() => preview.classList.add('is-updated'));
            clearTimeout(this.highlightTimer); this.highlightTimer = setTimeout(() => preview.classList.remove('is-updated'), 900);
            this.updatePreviewThumbnail(gallery); updateVisibility();
          }
          button.disabled = !variant?.available;
          button.setAttribute('aria-disabled', String(!variant?.available));
          const nativePrice = form.querySelector('product-buy-price');
          if (nativePrice) price.textContent = nativePrice.textContent.trim();
          else {
            const mainPrice = document.querySelector('.zenith-luxury .product__price .price__regular');
            if (mainPrice) price.textContent = mainPrice.textContent.trim();
          }
        }, { signal: this.abort.signal });
      };
      if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', setup, { once: true, signal: this.abort.signal });
      else setup();
    }

    updatePreviewThumbnail(gallery) {
      cancelAnimationFrame(this.previewFrame);
      this.previewFrame = requestAnimationFrame(() => {
        if (!this.isConnected) return;
        const images=[this.querySelector('[data-mobile-design-image]'),this.selectionPreview?.querySelector('[data-mobile-design-image]')].filter(Boolean);
        const canvas = gallery.querySelector('[data-gallery-canvas]');
        const visual = gallery.querySelector('[data-gallery-visual]');
        if (canvas && !visual?.hidden) {
          try { const thumb = document.createElement('canvas'); thumb.width = 160; thumb.height = 118; thumb.getContext('2d').drawImage(canvas,0,0,160,118);const src=thumb.toDataURL('image/png');images.forEach(img=>{img.src=src;img.hidden=false;}); } catch { images.forEach(img=>img.hidden=true); }
        } else {
          const photo = gallery.parentElement.querySelector('media-gallery .is-selected img') || gallery.parentElement.querySelector('media-gallery img');
          images.forEach(img=>{const src=this.currentVariantImage||photo?.currentSrc||photo?.src;if(src){img.src=src;img.hidden=false;}else img.hidden=true;});
        }
      });
    }
    disconnectedCallback() { this.abort?.abort(); this.observer?.disconnect(); this.galleryObserver?.disconnect(); this.backButton?.remove();this.selectionPreview?.remove();cancelAnimationFrame(this.previewFrame);clearTimeout(this.highlightTimer);clearTimeout(this.selectionHighlightTimer); }
  }

  customElements.define('zenith-configuration-summary', ZenithConfigurationSummary);
  customElements.define('zenith-purchase-bar', ZenithPurchaseBar);
})();




document.addEventListener('click',event=>{
  const link=event.target.closest('[data-guilds-warranty-link]');if(!link)return;
  const panel=document.getElementById(link.getAttribute('href').slice(1));if(!panel)return;
  event.preventDefault();panel.open=true;panel.scrollIntoView({block:'start',behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth'});panel.querySelector('summary').focus({preventScroll:true});
});



